import { Chip, TextField } from '@mui/material';
import styles from './TextFieldArray.module.css';
import { useState } from 'react';

export interface ITextFieldArray {
  handleFormData: (data: any) => void;
  placeholder?: string;
  name: string;
}

const TextFieldArray: React.FC<ITextFieldArray> = ({ handleFormData, placeholder, name }) => {
  const [chips, setChips] = useState<string[]>([]);
  const [special_qualification_input, setSpecialQualificationInput] = useState('');

  const handleKeyDown = (event: any) => {
    if (event.key === 'Enter') {
      event.preventDefault(); // Prevent form submission or any other default action
      if (special_qualification_input.trim()) {
        handleFormData([...chips, special_qualification_input.trim()]);
        setChips([...chips, special_qualification_input.trim()]);
        setSpecialQualificationInput('');
      }
    }
  };

  return (
    <>
      <TextField
        className={styles.input}
        type="text"
        placeholder={placeholder}
        name={name}
        onKeyDown={handleKeyDown} // Add the onKeyDown event listener
        value={special_qualification_input}
        onChange={(e) => setSpecialQualificationInput(e.target.value)}
        fullWidth
      />
      <div className={styles.chipContainer}>
        {chips.map((chip, index) => (
          <Chip
            key={index}
            label={chip}
            className={styles.chip}
            onDelete={() => {
              const newChips = chips.filter((_, i) => i !== index);
              handleFormData(newChips);
              setChips(newChips);
            }}
          />
        ))}
      </div>
    </>
  );
};

export default TextFieldArray;
